<template>
  <div
    v-if="showPagination"
    class="b-pagination-as-view-more"
    aria-label="Page navigation">
    <div v-if="showCounter">
      You have viewed {{ displayedCount }} of {{ totalRecords }} items
    </div>
    <div v-if="showViewMore" class="d-flex justify-content-center">
      <button
        type="button"
        class="btn btn-outline-primary"
        @click="onClickPage">
        <span>{{ dictionary.paginationViewMore }}</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    totalRecords: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      default: 10,
    },
    currentPage: {
      type: Number,
      default: 1,
      required: true,
    },
    showCounter: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  emits: ['pagechanged'],
  computed: {
    displayedCount() {
      if (this.totalPages === this.currentPage) {
        return this.totalRecords
      }

      return this.currentPage * this.perPage
    },

    totalPages() {
      return Math.ceil(this.totalRecords / this.perPage)
    },

    pages() {
      // https://stackoverflow.com/questions/3746725/how-to-create-an-array-containing-1-n
      return Array.from({ length: this.totalPages }, (_, i) => i + 1)
    },

    showPagination() {
      if (this.totalPages <= 1) {
        return false
      }

      return true
    },

    showViewMore() {
      if (this.totalPages <= 1) {
        return false
      }

      if (this.totalPages === this.currentPage) {
        return false
      }

      return true
    },
  },

  methods: {
    onClickPage() {
      this.$emit('pagechanged', this.currentPage + 1)
    },
  },
}
</script>
